var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bannerList.length > 0)?_c('div',{staticClass:"banner_container"},[_c('img',{staticClass:"banner_img",attrs:{"src":_vm.bannerList[0].address,"alt":""}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }